import React, {Component} from 'react'
import {Button} from 'antd';
import {Link} from 'react-router';

class StationButtonCamera extends Component {
  handleClick(station) {
    this.props.onStationButtonCamera(station)
  }
  render() {
    const {station} = this.props
    const to = `/stations/${station.ID}/cameras`
    return <Link to={to} onClick={() => this.handleClick(station)}>
      <Button type="primary" ghost="ghost" size="small">
        Camera
      </Button>
    </Link>
  }
}

export default StationButtonCamera;



// WEBPACK FOOTER //
// ./src/components/StationButtonCamera.js